import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'

import { BlueHeader } from '@/components/layout/blue-header'
import { ResearchBarFormShell } from '@/components/research-bar/research-bar-form-shell'

export const Route = createFileRoute('/recherche')({
  component: ResearchBarComponent,
})

function ResearchBarComponent() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  if (pathname !== '/recherche') {
    return <Outlet />
  }

  return (
    <div className="flex min-h-screen min-w-screen flex-1 flex-col gap-5 bg-[url('/images/default-background.jpg')] bg-cover bg-center bg-no-repeat">
      <div>
        <BlueHeader />
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-5">
        <ResearchBarFormShell />
        <div className="text-sm font-medium text-white">ou</div>
        <Link
          className="rounded-md border-2 border-white px-12 py-4 text-white hover:underline hover:underline-offset-2"
          to="/devis"
        >
          <div className="font-semibold text-white">Faire un devis sur mesure</div>
        </Link>
        <span className="text-center text-sm font-medium text-white">
          (Congés Bonifiés, UM, Groupes, Plusieurs départs, Demandes particulières…)
        </span>
      </div>
    </div>
  )
}
